import { useEffect, useState } from 'react';
import {
  getPendingImportHandoff,
  subscribeImportHandoff,
  type PendingImportHandoff,
} from '@/lib/importHandoff';

/**
 * T3077 — čakajoča predaja popisa s spletne strani, ki sledi spremembam.
 *
 * Osveži se ob zajemu, prevzemu ali zavrženju v tem zavihku, ob spremembi v
 * drugem zavihku (`storage`) in ob poteku roka — pasica takrat izgine sama.
 */
export function usePendingImportHandoff(): PendingImportHandoff | null {
  const [pending, setPending] = useState<PendingImportHandoff | null>(null);

  useEffect(() => {
    // Branje v efektu, ne med izrisom: potekel vnos se ob branju pobriše in
    // sproži dogodek spremembe, ki ga med izrisom ne smemo oddati.
    const refresh = () => setPending(getPendingImportHandoff());
    refresh();
    return subscribeImportHandoff(refresh);
  }, []);

  useEffect(() => {
    if (!pending) return;
    const timer = setTimeout(
      () => setPending(getPendingImportHandoff()),
      Math.max(0, pending.expiresAt - Date.now()) + 50,
    );
    return () => clearTimeout(timer);
  }, [pending]);

  return pending;
}
